import { Outlet } from 'react-router-dom';
import CustomHistory from '../components/customHistory/CustomHistorySection';
import Footer from '../components/Footer/FooterSection';
import Header from '../components/Header/HeaderSection';
import OrderBox from '../components/OrderBox/OrderBoxSection';
import '../styles/cart.scss';

const Cart = () => {
 // const navigate = useNavigate();

 return (
  <>
   <Header></Header>

   <CustomHistory></CustomHistory>

   <div className="cart content">
    <div className="cartGrid">
     <Outlet></Outlet>
     <OrderBox></OrderBox>
    </div>
   </div>

   <Footer></Footer>
  </>
 );
};

export default Cart;
